import { Link } from 'react-router-dom'

import classes from './MobileMenu.module.scss'
import { GetLoggedInMenuItemsParams, MobileMenuItem } from './MobileMenu.types'
import {
  getAccountItems,
  getOffersItems,
  getSupportItems,
} from '../desktop-menu/DesktopMenu.content'

export const getLoggedOutMobileMenuItems = ({
  marketingUrl,
  communityUrl,
}: {
  marketingUrl: string
  communityUrl: string
}): MobileMenuItem[] => [
  {
    id: 'all-plans-menu-item',
    label: 'All plans',
    href: `${marketingUrl}all-plans`,
  },
  {
    id: 'gift-card-menu-item',
    label: 'Bag up to £20',
    href: `${marketingUrl}refer-a-friend`,
  },
  {
    id: 'group-plans-menu-item',
    label: 'Group plans',
    href: `${marketingUrl}group-plans`,
  },
  {
    id: 'community-menu-item',
    label: 'Community',
    href: `${communityUrl}`,
  },
  {
    id: 'support-menu-item',
    label: 'Support',
    href: 'https://help.smarty.co.uk',
  },
  {
    id: 'about-menu-item',
    label: 'About',
    href: `${marketingUrl}about-us`,
  },
  {
    id: 'log-in-menu-item',
    label: 'Log in',
    href: '/login',
    as: Link,
    className: classes.logInOut,
  },
]

export const getLoggedInMobileMenuItems = ({
  isAbandonedAccount,
  isActivated,
  isNotInGroup,
  userHasUsage,
  userHasAgreement,
  memberWithNickname,
}: GetLoggedInMenuItemsParams): MobileMenuItem[] => [
  {
    id: 'dashboard-menu-item',
    label: 'My dashboard',
    href: '/dashboard',
    as: Link,
  },
  {
    id: 'account-sub-menu',
    label: 'My account',
    items: getAccountItems({
      isActivated,
      isNotInGroup,
      userHasUsage,
      userHasAgreement,
    }),
  },
  {
    id: 'support-menu-item',
    label: 'Support',
    items: getSupportItems({ isActivated }),
  },
  {
    id: 'offers-sub-menu',
    label: 'Offers',
    items: getOffersItems({
      isActivated,
      isAbandonedAccount,
      isNotInGroup,
      memberWithNickname,
    }),
  },
  {
    id: 'log-out-menu-item',
    label: 'Log out',
    className: classes.logInOut,
    as: Link,
    // onClick: logOut,
    href: '/dashboard/sign-out',
  },
]
